// Mock data for Altiora Business Solutions

export const services = [
  {
    id: '1',
    title: 'Accounts Receivable (AR)',
    icon: 'DollarSign',
    description: 'End-to-end AR management to optimize your cash flow and reduce outstanding balances.',
    features: [
      'Invoice generation and management',
      'Payment tracking and reconciliation',
      'Collections and follow-ups',
      'Aging analysis and reporting',
      'Customer account management'
    ]
  },
  {
    id: '2',
    title: 'Accounts Payable (AP)',
    icon: 'CreditCard',
    description: 'Streamline your AP processes with accuracy, efficiency, and timely vendor payments.',
    features: [
      'Invoice processing and verification',
      'Vendor management',
      'Payment scheduling and execution',
      'Expense categorization',
      '3-way matching and compliance'
    ]
  },
  {
    id: '3',
    title: 'Claims Recovery',
    icon: 'TrendingUp',
    description: 'Maximize your recoveries with our proven claims recovery strategies and expertise.',
    features: [
      'Outstanding debt recovery',
      'Claims analysis and validation',
      'Negotiation and settlement',
      'Best recoveries within 30 days',
      'Comprehensive reporting'
    ]
  },
  {
    id: '4',
    title: 'Customer Services',
    icon: 'Headphones',
    description: '24/7 customer support for returns, subscriptions, and general inquiries.',
    features: [
      'Return management',
      'Subscription plan support',
      'Multi-channel support',
      'Query resolution',
      'Customer satisfaction tracking'
    ]
  },
  {
    id: '5',
    title: 'Purchase Order Management',
    icon: 'Package',
    description: 'Comprehensive purchase order entry and management in your ERP systems.',
    features: [
      'Purchase order data entry in ERP',
      'PO validation and verification',
      'Vendor purchase order tracking',
      'ERP system integration',
      'PO status updates and reporting'
    ]
  },
  {
    id: '6',
    title: 'Daily Invoicing Process',
    icon: 'FileText',
    description: 'Automated daily invoicing in ARP systems for accurate and timely billing.',
    features: [
      'Automated invoice generation in ARP',
      'Daily processing and validation',
      'Invoice data entry and verification',
      'System integration and updates',
      'Error resolution and quality checks'
    ]
  },
  {
    id: '7',
    title: 'Journal & Ledger Entries',
    icon: 'BookOpen',
    description: 'Accurate journal and ledger entry management for complete financial record-keeping.',
    features: [
      'Daily journal entry processing',
      'General ledger maintenance',
      'Account reconciliation',
      'Period-end adjustments',
      'Audit trail documentation'
    ]
  }
];

export const industries = [
  {
    id: '1',
    name: 'Manufacturing',
    icon: 'Factory',
    description: 'Specialized accounting solutions for manufacturing companies with complex inventory and supply chain needs.'
  },
  {
    id: '2',
    name: 'Healthcare',
    icon: 'Heart',
    description: 'HIPAA-compliant financial services tailored for healthcare providers and medical practices.'
  },
  {
    id: '3',
    name: 'Information Technology',
    icon: 'Laptop',
    description: 'Scalable accounting solutions for IT companies, SaaS businesses, and tech startups.'
  },
  {
    id: '4',
    name: 'E-commerce',
    icon: 'ShoppingBag',
    description: 'Order-to-cash optimization for e-commerce businesses with high transaction volumes.'
  }
];

export const stats = [
  {
    id: '1',
    value: '17+',
    label: 'Years of Experience',
    description: 'Industry expertise'
  },
  {
    id: '2',
    value: '24/7',
    label: 'Global Support',
    description: 'Always available'
  },
  {
    id: '3',
    value: '30',
    label: 'Days to Recovery',
    description: 'Best results'
  },
  {
    id: '4',
    value: '100%',
    label: 'Client Satisfaction',
    description: 'Proven track record'
  }
];

export const testimonials = [
  {
    id: '1',
    company: 'Tech Startup Inc.',
    industry: 'IT',
    text: 'Altiora transformed our accounts receivable process. We saw a 40% reduction in outstanding balances within the first quarter.',
    author: 'Sarah Johnson',
    position: 'CFO'
  },
  {
    id: '2',
    company: 'MediCare Solutions',
    industry: 'Healthcare',
    text: 'Professional, efficient, and reliable. Their claims recovery service exceeded our expectations with exceptional results.',
    author: 'Dr. Michael Chen',
    position: 'Practice Manager'
  },
  {
    id: '3',
    company: 'E-Shop Online',
    industry: 'E-commerce',
    text: 'The 24/7 customer service support has been a game-changer for our business. Highly recommended!',
    author: 'Emily Rodriguez',
    position: 'Operations Director'
  }
];

export const whyChooseUs = [
  {
    id: '1',
    title: 'Competitive Pricing',
    description: 'Cost-effective solutions designed for small to mid-cap companies without compromising quality.'
  },
  {
    id: '2',
    title: 'Proven Expertise',
    description: '17 years of experience working with Fortune 500 companies and small businesses alike.'
  },
  {
    id: '3',
    title: 'Global 24/7 Availability',
    description: 'Round-the-clock support from our team in India, ensuring seamless operations for US businesses.'
  },
  {
    id: '4',
    title: 'Best-in-Class Results',
    description: 'Consistent track record of achieving maximum recoveries and optimizing financial processes.'
  }
];

// Contact form submission (mock)
export const contactUtils = {
  submitForm: (formData) => {
    // Mock form submission
    console.log('Form submitted:', formData);
    // Store in localStorage for demo
    const submissions = JSON.parse(localStorage.getItem('altiora_contacts') || '[]');
    submissions.push({
      ...formData,
      id: Date.now(),
      submittedAt: new Date().toISOString()
    });
    localStorage.setItem('altiora_contacts', JSON.stringify(submissions));
    return { success: true, message: 'Thank you! We will contact you within 24 hours.' };
  },
  
  getSubmissions: () => {
    return JSON.parse(localStorage.getItem('altiora_contacts') || '[]');
  }
};
